export const SET_FILTER        = 'SET_FILTER';
export const RESET_FILTERS     = 'RESET_FILTERS';
export const SET_PAGE          = 'SET_PAGE';
export const SET_CATEGORY_NAMES = 'SET_CATEGORY_NAMES';

export const setFilter = ( key, value ) => ( { type: SET_FILTER, key, value } );
export const setPage   = ( page )        => ( { type: SET_PAGE, page } );
export const resetFilters = ()           => ( { type: RESET_FILTERS } );

export const setSearch          = ( value ) => setFilter( 'search', value );
export const setCategories      = ( value ) => setFilter( 'categories', value );
export const setTags            = ( value ) => setFilter( 'tags', value );
export const setMinPrice        = ( value ) => setFilter( 'minPrice', value );
export const setMaxPrice        = ( value ) => setFilter( 'maxPrice', value );
export const setOrderby         = ( value ) => setFilter( 'orderby', value );
export const setIncludeChildren = ( value ) => setFilter( 'includeChildren', value );
export const setCategoryNames   = ( names ) => ( { type: SET_CATEGORY_NAMES, names } );
